import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TagComponent } from "@merchant-webapp/components";
import { TranslocoPipe } from "@jsverse/transloco";
import { NgForOf } from "@angular/common";

@Component({
  selector: "er-block-view-card-list",
  templateUrl: "./block-view-card-list.component.html",
  imports: [TagComponent, TranslocoPipe, TagComponent, NgForOf],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BlockViewCardListComponent {
  @Input()
  public title!: string;

  @Input()
  public listElements!: string[] | undefined;

  @Input()
  public elementTranslationBase!: string | undefined;

  @Input()
  public elementTranslationMap: { [key: string]: string } | undefined;

  @Input()
  public hasHr = true;
}
